<div class="payment-flow-page min-h-screen bg-[#f4f5f7] font-sans text-copy">
  <app-headerhome></app-headerhome>

  @if (bookingdetails) {
    <main class="payment-flow-shell mx-auto max-w-[1080px] px-[22px] pb-[140px] pt-[22px]">
      <button type="button" class="payment-back-button focus-ring" (click)="currentStep === 'payment' ? backToPassenger() : backToBuses()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        {{ currentStep === 'payment' ? 'Back to passenger details' : 'Back to buses' }}
      </button>

      <ol class="booking-progress" aria-label="Booking progress">
        <li class="is-complete">
          <span class="progress-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>
          </span>
          <strong>Seats</strong>
          <i></i>
        </li>
        <li [class.is-complete]="currentStep === 'payment'" [class.is-current]="currentStep === 'passenger'">
          <span class="progress-circle">
            @if (currentStep === 'payment') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>
            } @else {
              2
            }
          </span>
          <strong>Passenger details</strong>
          <i></i>
        </li>
        <li [class.is-current]="currentStep === 'payment'">
          <span class="progress-circle">3</span>
          <strong>Payment</strong>
        </li>
      </ol>

      <form id="ngForm" [formGroup]="paymentForm" (ngSubmit)="submitForm()">
        @if (currentStep === 'passenger') {
          <div class="payment-flow-grid">
            <div class="passenger-flow-column">
              @for (journey of journeyFareSummaries; track journey.label) {
                <section class="trip-summary-card">
                  @if (config?.self?.logo) {
                    <img [src]="config.self.logo" [alt]="config.site.name">
                  }
                  <div class="min-w-0 flex-1">
                    <small class="journey-direction-label">{{ journey.label }}</small>
                    <h1>{{ journey.from }} → {{ journey.to }}</h1>
                    <p>
                      {{ journey.date }} · {{ formatJourneyTime(journey.details.result.departure_time) }} → {{ formatJourneyTime(journey.details.result.arrival_time) }}
                    </p>
                  </div>
                  <span>{{ journey.seats.length }} {{ journey.seats.length === 1 ? 'seat' : 'seats' }} ·
                    @for (seat of journey.seats; track seat.id; let last = $last) {
                      {{ seat.id }}{{ last ? '' : ', ' }}
                    }
                  </span>
                </section>
              }

              <section class="passenger-details-section">
                <h2>Passenger details</h2>
                <div class="passenger-card-list">
                  @for (seat of passengerSeats; track seat.id; let seatno = $index) {
                    <article class="passenger-card" [class.is-open]="expandedPassenger === seatno" [class.is-complete]="passengerIsComplete(seat)">
                      <button type="button" class="passenger-card-header" (click)="togglePassenger(seatno)">
                        <span class="passenger-number">{{ passengerIsComplete(seat) ? '✓' : seatno + 1 }}</span>
                        <span class="passenger-card-copy">
                          <strong>Passenger {{ seatno + 1 }}</strong>
                          <small>{{ passengerSeatLabel(seatno) }} · {{ seat.space_type === 'normal' ? 'Standard' : (seat.space_type | titlecase) }}@if (passengerName(seat)) { · {{ passengerName(seat) }} }</small>
                        </span>
                        <span class="passenger-status">{{ passengerIsComplete(seat) ? 'Complete' : 'Action required' }}</span>
                        <svg class="passenger-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
                      </button>

                      @if (expandedPassenger === seatno) {
                        <div class="passenger-card-body">
                          <div class="passenger-fields">
                            <label>
                              <span>First name <b>*</b></span>
                              <input type="text" [formControlName]="'fname' + seat.id" autocomplete="given-name" placeholder="First name">
                              @if (paymentForm.get('fname' + seat.id)?.touched && paymentForm.get('fname' + seat.id)?.invalid) {
                                <small class="field-error">Enter a valid first name.</small>
                              }
                            </label>
                            <label>
                              <span>Last name <b>*</b></span>
                              <input type="text" [formControlName]="'lname' + seat.id" autocomplete="family-name" placeholder="Last name">
                              @if (paymentForm.get('lname' + seat.id)?.touched && paymentForm.get('lname' + seat.id)?.invalid) {
                                <small class="field-error">Enter a valid last name.</small>
                              }
                            </label>
                            <label>
                              <span>Document type <b>*</b></span>
                              <select [formControlName]="'doctype' + seat.id">
                                @for (documentType of documentTypes; track documentType.value) {
                                  <option [value]="documentType.value">{{ documentType.label }}</option>
                                }
                              </select>
                            </label>
                            <label>
                              <span>Document number <b>*</b></span>
                              <input type="text" [formControlName]="'idno' + seat.id" autocomplete="off" placeholder="Enter document number">
                              @if (paymentForm.get('idno' + seat.id)?.touched && paymentForm.get('idno' + seat.id)?.invalid) {
                                <small class="field-error">Enter a valid document number.</small>
                              }
                            </label>
                            <label>
                              <span>Nationality <b>*</b></span>
                              <select [formControlName]="'residence' + seat.id" autocomplete="country-name">
                                <option value="" disabled>Select nationality</option>
                                @for (country of countries; track country) {
                                  <option [value]="country">{{ country }}</option>
                                }
                              </select>
                              @if (paymentForm.get('residence' + seat.id)?.touched && paymentForm.get('residence' + seat.id)?.invalid) {
                                <small class="field-error">Select the passenger's nationality.</small>
                              }
                            </label>
                            <label class="passenger-phone-label">
                              <span>Passenger phone <b>*</b></span>
                              <div class="passenger-phone-field">
                                <select [formControlName]="'phonecode' + seat.id" aria-label="Passenger phone country code">
                                  @for (country of passengerPhoneCountries; track country.dialCode) {
                                    <option [value]="country.dialCode">+{{ country.dialCode }} {{ country.name }}</option>
                                  }
                                </select>
                                <input type="tel" [formControlName]="'phoneno' + seat.id" autocomplete="tel" inputmode="tel" [placeholder]="passengerPhonePlaceholder(seat)">
                              </div>
                              @if (paymentForm.get('phoneno' + seat.id)?.touched && paymentForm.get('phoneno' + seat.id)?.invalid) {
                                <small class="field-error">Enter a valid international phone number.</small>
                              }
                            </label>
                            @if (seatno === 0) {
                              <label class="is-full">
                                <span>Ticket email <b>*</b></span>
                                <input formControlName="email" type="email" autocomplete="email" placeholder="you@example.com">
                                @if (paymentForm.get('email')?.touched && paymentForm.get('email')?.invalid) {
                                  <small class="field-error">Enter a valid email address for the ticket.</small>
                                }
                              </label>
                            }
                            <label>
                              <span>Special assistance <em>Optional</em></span>
                              <select [formControlName]="'assistance' + seat.id">
                                <option value="">None</option>
                                <option value="wheelchair">Wheelchair access</option>
                                <option value="elderly">Elderly assistance</option>
                                <option value="infant">Travelling with infant</option>
                              </select>
                            </label>
                          </div>
                          <button type="button" class="save-passenger-button" (click)="savePassenger(seatno)">Save passenger</button>
                        </div>
                      }
                    </article>
                  }
                </div>
              </section>

              @if (editingBoarding) {
                <section class="boarding-edit-card">
                  <div>
                    <h2>Edit boarding &amp; drop-off</h2>
                    <p>Your bus, seats and passenger details will stay unchanged.</p>
                  </div>
                  <div class="boarding-edit-fields">
                    <label>
                      <span>Boarding point</span>
                      <select [value]="draftPickupLocation" (change)="draftPickupLocation = $any($event.target).value">
                        @for (option of boardingPointOptions; track $index) {
                          <option [value]="pointLabel(option)">{{ pointLabel(option) }}</option>
                        }
                      </select>
                    </label>
                    <label>
                      <span>Drop-off point</span>
                      <select [value]="draftDropoffLocation" (change)="draftDropoffLocation = $any($event.target).value">
                        @for (option of dropoffPointOptions; track $index) {
                          <option [value]="pointLabel(option)">{{ pointLabel(option) }}</option>
                        }
                      </select>
                    </label>
                  </div>
                  <div class="boarding-edit-actions">
                    <button type="button" (click)="cancelBoardingEdit()">Cancel</button>
                    <button type="button" (click)="saveBoardingSelection()" [disabled]="!draftPickupLocation || !draftDropoffLocation">Save changes</button>
                  </div>
                </section>
              } @else {
                <section class="boarding-review-card">
                  <div>
                    <span class="review-pin is-pickup">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M12 22s8-4.5 8-11a8 8 0 1 0-16 0c0 6.5 8 11 8 11z"/><circle cx="12" cy="11" r="2.4"/></svg>
                    </span>
                    <p><small>Boarding</small><strong>{{ bookingdetails.pickup_location }}</strong></p>
                  </div>
                  <div>
                    <span class="review-pin is-dropoff">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M12 22s8-4.5 8-11a8 8 0 1 0-16 0c0 6.5 8 11 8 11z"/><path d="m8.5 11.5 2.5 2.5 4.5-4.5"/></svg>
                    </span>
                    <p><small>Drop-off</small><strong>{{ bookingdetails.dropoff_location }}</strong></p>
                  </div>
                  <button type="button" (click)="beginBoardingEdit()">Edit</button>
                </section>
              }
            </div>

            <aside class="fare-summary-card">
              <div class="summary-card-heading">
                <span class="summary-heading-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 3h10a2 2 0 0 1 2 2v16l-3-2-4 2-4-2-3 2V5a2 2 0 0 1 2-2Z"/><path d="M9 8h6M9 12h6"/></svg>
                </span>
                <div><h2>Fare summary</h2><p>Review your trip total</p></div>
              </div>
              @for (journey of journeyFareSummaries; track journey.label) {
                <section class="journey-fare-breakdown summary-journey-card">
                  <div class="summary-journey-heading">
                    <span class="journey-direction-label">{{ journey.label }}</span>
                    <span>{{ journey.date }}</span>
                  </div>
                  <h3>{{ journey.from }} <span aria-hidden="true">→</span> {{ journey.to }}</h3>
                  <dl>
                    @for (group of journey.fareGroups; track group.label) {
                      <div><dt>{{ group.label }} seat × {{ group.count }}</dt><dd>{{ payableCurrencyLabel }} {{ group.total | number }}</dd></div>
                    }
                    @if (journey.bookingFee) {
                      <div><dt>Booking fee</dt><dd>{{ payableCurrencyLabel }} {{ journey.bookingFee | number }}</dd></div>
                    }
                  </dl>
                  <div class="journey-subtotal"><span>Subtotal</span><strong>{{ payableCurrencyLabel }} {{ journey.total | number }}</strong></div>
                </section>
              }
              <div class="fare-total"><strong>Total payable</strong><b>{{ payableCurrencyLabel }} {{ payableAmount | number }}</b></div>
              <button type="button" class="primary-flow-button" (click)="continueToPayment()">Continue to payment</button>
              <p class="secure-caption">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>
                256-bit secured payment
              </p>
            </aside>
          </div>

          <div class="mobile-payment-bar">
            <div><small>Total payable</small><strong>{{ payableCurrencyLabel }} {{ payableAmount | number }}</strong></div>
            <button type="button" (click)="continueToPayment()">Continue</button>
          </div>
        } @else {
          <div class="payment-flow-grid">
            <section class="payment-method-column">
              <div class="payment-step-header">
                <h1>Choose how to pay</h1>
                <span class="payment-secure-note">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>
                  256-bit secured
                </span>
              </div>

              @if (availablePaymentCurrencies.length > 1) {
                <div class="payment-step-card">
                  <div class="payment-step-heading">
                    <strong>1 · Pay in</strong>
                    <span>Sets the methods below</span>
                  </div>
                  <div class="payment-currency-tabs" role="tablist" aria-label="Payment currency">
                    @for (currency of availablePaymentCurrencies; track currency) {
                      <button type="button" class="payment-currency-tab" role="tab" [attr.aria-selected]="selectedPaymentCurrency === currency" [class.is-active]="selectedPaymentCurrency === currency" (click)="onPaymentCurrencyChange(currency)">
                        <span class="payment-currency-tab-top">
                          <b>{{ currencyCountryCode(currency) }}</b>
                          <span class="payment-currency-tab-logos">
                            @for (logo of currencyLogos(currency); track logo) {
                              <img [src]="logo" alt="">
                            }
                          </span>
                        </span>
                        <small>{{ currencyDisplayName(currency) }}</small>
                      </button>
                    }
                  </div>
                </div>
              }

              <div class="payment-step-card">
                <div class="payment-step-heading">
                  <strong>2 · Mobile money account</strong>
                  <span>{{ paymentMethodCountLabel }}</span>
                </div>

                @if (paymentOptionsLoading) {
                  <div class="payment-method-skeleton" aria-hidden="true">
                    <div class="skeleton-row"><span class="skeleton-avatar"></span><span class="skeleton-lines"><b></b><i></i></span></div>
                    <div class="skeleton-row"><span class="skeleton-avatar"></span><span class="skeleton-lines"><b></b><i></i></span></div>
                  </div>
                  <p class="payment-step-note">Checking which methods accept {{ currencyCountryCode(selectedPaymentCurrency) }}…</p>
                } @else if (enabledPaymentOptions.length) {
                  <div class="payment-method-list">
                    @for (option of enabledPaymentOptions; track option.formValue) {
                      <label class="payment-method-card">
                        <img [src]="option.logo" [alt]="option.name">
                        <span class="method-copy">
                          <strong>{{ option.name }}</strong>
                          <small>{{ methodSubLabel(option) }}</small>
                        </span>
                        <span class="method-fee" [class.has-charge]="option.extraCharge > 0">{{ methodFeeLabel(option) }}</span>
                        <input type="radio" formControlName="paymentMethod" [value]="option.formValue" (change)="onPaymentMethodChange(option.formValue)">
                        <span class="method-radio"></span>
                      </label>
                    }
                  </div>

                  <div class="payment-confirm-section">
                    <strong class="payment-step-heading is-inline">3 · Confirm and pay</strong>
                    <div class="payment-breakdown-card">
                      <div class="payment-breakdown-row"><span>Fare</span><strong>{{ payableCurrencyLabel }} {{ payableFareAmount | number }}</strong></div>
                      @if (paymentExtraCharge > 0) {
                        <div class="payment-breakdown-row"><span>{{ paymentMethodShortName }} charge</span><strong>{{ payableCurrencyLabel }} {{ paymentExtraCharge | number }}</strong></div>
                      }
                      <div class="payment-breakdown-row is-total"><span>Total payable</span><b>{{ payableCurrencyLabel }} {{ payableAmount | number }}</b></div>
                    </div>

                    <label class="payment-phone-label">
                      <span>{{ paymentMethodShortName }} number</span>
                      <div>
                        <input formControlName="countryCode" type="hidden">
                        <span class="dial-code-static">+{{ selectedCountryCode }}</span>
                        <input formControlName="mobileNumber" type="tel" inputmode="tel" autocomplete="tel" placeholder="Phone number">
                      </div>
                      @if (paymentForm.get('mobileNumber')?.touched && paymentForm.get('mobileNumber')?.invalid) {
                        <small class="field-error">Enter a valid payment phone number.</small>
                      }
                    </label>
                    <p class="payment-hint">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8h.01M11 12h1v4h1"/></svg>
                      We'll send a {{ paymentMethodShortName }} request to this number. Enter your PIN on your phone—we never ask for it here.
                    </p>
                    <label class="terms-checkbox">
                      <input type="checkbox" [checked]="accepted_terms" (change)="acceptedTerms()">
                      <span>I confirm the passenger details and accept the applicable <a routerLink="/terms-and-condition" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">terms and conditions</a>.</span>
                    </label>
                    @if (submitted && !accepted_terms) {
                      <small class="field-error">Please accept the terms and conditions.</small>
                    }
                    @if (isError) {
                      <div class="payment-error">{{ errorMessage }}</div>
                    }
                    <button type="submit" class="primary-flow-button" [disabled]="loading || !enabledPaymentOptions.length">
                      {{ loading ? 'Processing payment…' : 'Pay ' + payableCurrencyLabel + ' ' + (payableAmount | number) + ' with ' + paymentMethodShortName }}
                    </button>
                  </div>
                } @else {
                  <div class="payment-empty-state">
                    <span class="payment-empty-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 9v4M12 17h.01"/><path d="M10.3 3.9 2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/></svg>
                    </span>
                    <strong>No {{ currencyCountryCode(selectedPaymentCurrency) }} method for this operator</strong>
                    <p>{{ paymentOptionsError || ('Mash Poa has not enabled a mobile money provider that settles in ' + selectedPaymentCurrency + ' on this route. Pick another currency to continue.') }}</p>
                    @if (otherPaymentCurrency; as otherCurrency) {
                      <button type="button" class="payment-empty-action" (click)="onPaymentCurrencyChange(otherCurrency)">Pay in {{ currencyCountryCode(otherCurrency) }} instead</button>
                    }
                  </div>
                }
              </div>
            </section>

            <aside class="fare-summary-card booking-summary-card">
              <div class="summary-card-heading booking-summary-heading">
                <span class="summary-heading-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 3h10a2 2 0 0 1 2 2v16l-3-2-4 2-4-2-3 2V5a2 2 0 0 1 2-2Z"/><path d="M9 8h6M9 12h6"/></svg>
                </span>
                <div><h2>Booking summary</h2><p>Review before you pay</p></div>
              </div>
              @for (journey of journeyFareSummaries; track journey.label) {
                <section class="booking-journey-section summary-journey-card">
                  <div class="summary-journey-heading">
                    <small class="journey-direction-label">{{ journey.label }}</small>
                    <span>{{ journey.date }}</span>
                  </div>
                  <h3>{{ journey.from }} → {{ journey.to }}</h3>
                  <p class="booking-journey-time">
                    {{ formatJourneyTime(journey.details.result.departure_time) }} → {{ formatJourneyTime(journey.details.result.arrival_time) }}
                  </p>
                  <dl class="booking-detail-list booking-journey-details summary-detail-grid">
                    <div><dt>Boarding</dt><dd>{{ journey.details.pickup_location }}</dd></div>
                    <div><dt>Drop-off</dt><dd>{{ journey.details.dropoff_location }}</dd></div>
                    <div><dt>Seats</dt><dd>@for (seat of journey.seats; track seat.id; let last = $last) { {{ seat.id }}{{ last ? '' : ', ' }} }</dd></div>
                  </dl>
                  <dl class="booking-journey-fares">
                    @for (group of journey.fareGroups; track group.label) {
                      <div><dt>{{ group.label }} × {{ group.count }}</dt><dd>{{ payableCurrencyLabel }} {{ group.total | number }}</dd></div>
                    }
                    <div class="journey-subtotal"><dt>Subtotal</dt><dd>{{ payableCurrencyLabel }} {{ journey.total | number }}</dd></div>
                  </dl>
                </section>
              }
              <div class="booking-passenger-list">
                <div class="summary-section-title">
                  <span aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M4.5 21a7.5 7.5 0 0 1 15 0"/></svg>
                  </span>
                  <strong>Passenger details</strong>
                </div>
                @for (passenger of bookingSummaryPassengers; track passenger.seatNumber; let passengerIndex = $index) {
                  <section class="booking-passenger">
                    <h4><span class="summary-passenger-badge">{{ passengerIndex + 1 }}</span>Passenger {{ passengerIndex + 1 }}</h4>
                    <dl class="booking-detail-list">
                      <div><dt>Full name</dt><dd>{{ passenger.fullName }}</dd></div>
                      <div><dt>Phone number</dt><dd>{{ passenger.phoneNumber }}</dd></div>
                      <div><dt>Seat number</dt><dd>{{ passenger.seatNumber }}</dd></div>
                      <div><dt>Amount</dt><dd>{{ payableCurrencyLabel }} {{ passenger.amount | number }}</dd></div>
                    </dl>
                  </section>
                }
              </div>
              <div class="fare-total"><strong>Total payable</strong><b>{{ payableCurrencyLabel }} {{ payableAmount | number }}</b></div>
            </aside>
          </div>

          <div class="mobile-payment-bar">
            <div><small>Total payable</small><strong>{{ payableCurrencyLabel }} {{ payableAmount | number }}</strong></div>
            <button type="submit" [disabled]="loading || !enabledPaymentOptions.length">
              {{ loading ? 'Processing…' : 'Pay with ' + paymentMethodShortName }}
            </button>
          </div>
        }
      </form>
    </main>
  }

  @if (seatConflictOpen) {
    <div class="seat-conflict-dialog" role="dialog" aria-modal="true" aria-labelledby="seat-conflict-title">
      <div class="seat-conflict-backdrop"></div>
      <section>
        <span class="seat-conflict-icon" aria-hidden="true">!</span>
        <h2 id="seat-conflict-title">Choose another seat</h2>
        <p>{{ seatConflictMessage }}</p>
        <p class="seat-conflict-selection">
          Your selected {{ bookingdetails.seatsSelected.length === 1 ? 'seat' : 'seats' }}:
          <strong>@for (seat of bookingdetails.seatsSelected; track seat.id; let last = $last) { {{ seat.id }}{{ last ? '' : ', ' }} }</strong>
        </p>
        <div>
          <button type="button" (click)="cancelSeatConflict()">Cancel</button>
          <button type="button" (click)="chooseAnotherSeat()">Continue</button>
        </div>
      </section>
    </div>
  }

</div>
